import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum CommandCenterSecurityRight {
    CanViewInbox = 33000,
    CanViewQueues = 33001,
    CanCreatePersonalQueues = 33002,
    CanManageSharedQueues = 33003,
}

export class CommandCenterSecurityModule extends BaseSecurityModule<CommandCenterSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.CommandCenter,
            [
                { _id: CommandCenterSecurityRight.CanViewInbox, name: 'View My Inbox', basic: true },
                { _id: CommandCenterSecurityRight.CanViewQueues, name: 'View Queues', basic: true },
                { _id: CommandCenterSecurityRight.CanCreatePersonalQueues, name: 'Create/Edit Personal Queues', basic: false },
                { _id: CommandCenterSecurityRight.CanManageSharedQueues, name: 'Manage Shared Queues', basic: false },
            ] as SecurityRight<CommandCenterSecurityRight>[]
        );
    }

}
